import { css } from '@compiled/react';

import type { GlyphProps } from '@atlaskit/icon/types';

export const MenuIcon: React.FC<GlyphProps> = () => (
	<div
		css={css({
			width: '21px',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			gap: '4px',
		})}
	>
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
			<path d="M2 2H23" stroke="black" strokeWidth="3" strokeLinecap="round" />
		</svg>
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
			<path d="M2 2H23" stroke="black" strokeWidth="3" strokeLinecap="round" />
		</svg>
		<svg xmlns="http://www.w3.org/2000/svg" width="25" height="4" viewBox="0 0 25 4" fill="none">
			<path d="M2 2H23" stroke="black" strokeWidth="3" strokeLinecap="round" />
		</svg>
	</div>
);
